import { render, staticRenderFns } from "./OrganizationRelateForm.vue?vue&type=template&id=27c2599a&scoped=true&"
import script from "./OrganizationRelateForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationRelateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2599a",
  null
  
)

export default component.exports